<template>
  <li class="row flex-nowrap item">
    <div class="item-image">
      <product-image :image="image" />
    </div>
    <div class="item-information">
      <div class="col-xs flex pl35 start-xs details">
        <div>
          <router-link
            class="serif h4 name medium cl-black-1"
            :to="localizedRoute(productLink)"
            data-testid="productLink"
            @click.native="$store.commit('ui/setMicrocart', false)"
          >
            {{ $t(product.name) | htmlDecode }}
          </router-link>
          <div class="h6 cl-bg-tertiary pt5 sku" data-testid="productSku">
            {{ product.sku }}
          </div>
          <div class="relative">
            <custom-options-list :selected-options="product.options ? product.options : []" />
          </div>
          <div class="h6 bold flex middle-xs" v-if="product.availability_time.availability_time_enable == true">
            <i class="material-icons warning-message-icon py5 cl-accent">error_outline</i>
            <span class="asap-unavailable-message">{{ $t('This product is currently unavailable') }}</span>
          </div>
          <div class="h6 pt5 cl-error" v-if="product.errors && Object.keys(product.errors).length > 0">
            {{ product.errors | formatProductMessages }}
          </div>
          <div class="h6 pt5 cl-success" v-if="product.stock.is_in_stock && display_mode === 'shop'">
            {{ $t('In stock!') }}
          </div>
        </div>
        <div class="h5 pt5 cl-accent lh25 qty">
          <base-input-number
            v-if="!product.stock.is_qty_decimal"
            :name="$t('Quantity')"
            v-model="product.qty"
            :qty="product.stock.qty"
            :sku="product.sku"
            :qty-in-cart="qtyInCart"
            :qty-increments="product.stock.qty_increments"
            :use-qty-in-cart="false"
            :min="product.stock.min_sale_qty"
            @input="updateQuantity($event, product.stock.is_qty_decimal)"
          />
          <base-input-decimal-number
            v-else
            :name="$t('Quantity')"
            v-model="product.qty"
            :qty="product.stock.qty"
            :sku="product.sku"
            :qty-in-cart="qtyInCart"
            :qty-increments="product.stock.qty_increments"
            :use-qty-in-cart="false"
            :min="product.stock.min_sale_qty"
            @input="updateQuantity($event, product.stock.is_qty_decimal)"
          />
        </div>
      </div>
      <div class="flex align-right actions">
        <price :product="product" :qty="product.qty" />
        <div class="links">
          <div class="mt5" style="margin-right: -6px;" @click="removeItem">
            <remove-button />
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import config from 'config'
import Product from '@vue-storefront/core/compatibility/components/blocks/Microcart/Product'
import Total from '@vue-storefront/core/compatibility/components/blocks/Microcart/Total'

import ProductImage from 'theme/components/core/ProductImage'
import RemoveButton from './RemoveButton'
import BaseInputNumber from 'theme/components/core/blocks/Form/BaseInputNumber'
import BaseInputDecimalNumber from 'theme/components/core/blocks/Form/BaseInputDecimalNumber'
import { onlineHelper } from '@vue-storefront/core/helpers'
import CustomOptionsList from 'theme/components/core/blocks/Microcart/Product/CustomOptionsList'
import Price from 'theme/components/core/blocks/Microcart/Product/Price'
import { formatProductLink } from '@vue-storefront/core/modules/url/helpers'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  components: {
    RemoveButton,
    BaseInputNumber,
    BaseInputDecimalNumber,
    ProductImage,
    CustomOptionsList,
    Price
  },
  props: {
    display_mode: {
      type: String,
      required: false
    }
  },
  mixins: [Product, Total],
  computed: {
    productLink () {
      return formatProductLink({
        sku: this.product.sku,
        type_id: this.product.type_id,
        parentSku: this.product.parentSku ? this.product.parentSku : this.product.sku,
        slug: this.product.slug,
        configurable_children: []
      },
      currentStoreView().storeCode,
      this.partner.code,
      this.partner.location_code)
    },
    isOnline () {
      return onlineHelper.isOnline
    },
    image () {
      return {
        loading: this.thumbnail,
        src: this.thumbnail
      }
    },
    cartItem () {
      return this.$store.getters['cart/getCartItems'].find(item => item.entity_id === this.product.entity_id)
    },
    qtyInCart () {
      if (this.cartItem) {
        return parseFloat(this.cartItem.qty).toFixed(2)
      }
    }
  },
  data () {
    return {
      displayItemDiscounts: config.cart.displayItemDiscounts
    }
  }
}
</script>

<style lang="scss" scoped>
  .image {
    mix-blend-mode: multiply;
    vertical-align: top;
    width: 150px;
    @media (max-width: 768px) {
      width: 150px;
    }
  }

  .warning-message-icon {
    color: #ffA500;
    padding-right: 5px
  }

  .asap-unavailable-message {
    color: #ffA500;
  }

  .details {
    flex-direction: column;
    @media (max-width: 768px) {
      padding: 0 10px 0 20px;
    }
    @media (max-width: 375px) {
      padding: 0 10px 0 30px;
    }
    @media (max-width: 350px) {
      padding: 0 10px 0 15px;
    }
    @media (max-width: 320px) {
      padding: 0 7px 0 6px;
    }
  }

  .name {
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .options, .sku {
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .qty {
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  .actions {
    flex-direction: column;

    @media (max-width: 768px) {
      padding: 0;
      font-size: 12px;
    }

  }

  .price-special {
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  .price-original {
    text-decoration: line-through;
  }

  .price-regular {
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  input {
    width: 30px;
  }

  .flex-nowrap {
    flex-wrap: nowrap;
  }

  .fs-custom {
    font-size: 16px;
    @media (max-width: 768px) {
      font-size: 13px;
    }
  }
  .item{
    border-bottom: 1px solid #efeff4;
    padding: 10px 0;
    margin: 0 16px;

    &-image {
      display: flex;
      align-items: flex-start;
    }

    &-information {
      display: flex;
      flex: 1 1 auto;

      > div {
        justify-content: space-between;
      }

      @media only screen and (max-width: 425px) {
        flex-direction: column;

        .actions {
          flex-direction: row;
          padding-left: 20px;
          align-items: center;
        }
      }

      @media only screen and (max-width: 375px) {
        > div, .actions {
          padding-left: 12px;
        }
      }
    }
  }
</style>
<style>
  .qty label{
    display: none;
  }
</style>
